<div>
	<button
		mat-icon-button
		aria-label="Feedback"
		title="Feedback"
		type="button"
		(click)="showHistory()"
	>
		<mat-icon
			[matBadge]="showDot ? '!' : undefined"
			matBadgeColor="warn"
			matBadgeOverlap="false"
			>forum</mat-icon
		>
	</button>
</div>
